<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REPORTE DE MAXISACOS A REPASO</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>                
		        <modal-ayuda></modal-ayuda>
            </v-card-text>
            <v-row class="ml-1 mr-1">
                <v-col cols="3">
                    <label for="fechas col-md-9" >Búsqueda por Lote:</label>
                    <v-text-field v-model="lote" @keyup.enter.native="buscarLote" label="R-111111 (Presione Enter)" dense class="floa-right mr-1"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <label for="fechas col-md-9" >Búsqueda por Lote y Maxisaco:</label>
                    <v-text-field v-model="lote_jumbo" @keyup.enter.native="buscar" label="R-111111-1 (Presione Enter)" dense class="floa-right mr-1"></v-text-field>
                </v-col>
               
                <v-col cols="3">
                    <label for="fechas col-md-9" >Búsqueda por fechas:</label>
                    <date-picker class="col-md-9" v-model="fechas"  @change="cargarInfo" range-separator="|" range placeholder ="Seleccione Rango de Fechas" format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD"></date-picker>
                </v-col>

                 <v-col  cols="2">
                    <v-btn class="" color="green darken-1" dark small @click="descargarExcel" :disabled="url==''">Excel</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-row>
            <v-col>
                <v-card>
                    <v-simple-table fixed-header height="100%">
                        <template v-slot:default>
                        <thead>

                            <tr class="tr-title">
                                <th colspan="5" class="text-center borde-derecho">MAXISACO ORIGEN</th>
                                <th colspan="4" class="text-center">MAXISACO FINAL</th>
                            </tr>
                            <tr class="tr-title">
                                <th class="text-center">Lote</th>
                                <th class="text-center">Maxisaco N°</th>
                                <th class="text-center">Fecha Recolección</th>
                                <th class="text-center">Hora Recolección</th>
                                <th class="text-center borde-derecho">Peso (Kg)</th>

                                <th class="text-center">Fecha Repaso</th>
                                <th class="text-center">Hora Repaso</th>
                                <th class="text-center">Lote Final</th>
                                <th class="text-center">Maxisaco N°</th>  
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="j in jumbos_reproceso" :key="j.id">
                            <!-- <td class="text-center">{{ j.lote.nombre_lote }}</td>
                            <td class="text-center">{{ j.nro_jumbo }}</td>
                            <td class="text-center">{{ j.fecha_resultado_analisis| formatearFecha}}</td>
                            <td class="text-center">{{ j.fecha_resultado_analisis | formatearHora}}</td>
                            <td class="text-center borde-derecho">{{ j.peso }}</td>

                            <td class="text-center">{{ j.jumbo_destino? moment(j.jumbo_destino.fecha_resultado_analisis).format('DD-MM-YYYY') :''}}</td>
                            <td class="text-center">{{ j.jumbo_destino? moment(j.jumbo_destino.fecha_resultado_analisis).format('HH:mm') :''}}</td>
                            <td class="text-center">{{ j.jumbo_destino? j.jumbo_destino.lote.nombre_lote : ''}}</td>
                            <td class="text-center">{{ j.jumbo_destino? j.jumbo_destino.nro_jumbo : ''}}</td> -->
                            
                            <td class="text-center">{{ j.maxi_origen_lote }}</td>
                            <td class="text-center">{{ j.maxi_origen_nro }}</td>
                            <td class="text-center">{{ j.maxi_origen_fecha_produccion}}</td>
                            <td class="text-center">{{ j.maxi_origen_hora_produccion}}</td>
                            <td class="text-center borde-derecho">{{ j.maxi_origen_peso }}</td>

                            <td class="text-center">{{ j.maxi_final_fecha_produccion}}</td>
                            <td class="text-center">{{ j.maxi_final_hora_produccion}}</td>
                            <td class="text-center">{{ j.maxi_final_lote}}</td>
                            <td class="text-center borde-derecho">{{ j.maxi_final_nro}}</td>

                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-card>
            </v-col>
        </v-row>
        <!-- <pre>{{jumbos_reproceso}}</pre> -->
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        fechas:null,
        jumbos_reproceso:[],
        lote_jumbo:'',
        lote:'',
        url:''
    }),
    mounted() {
        this.fechas = new Date();
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Reporte de Maxisacos a Repaso`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se pueden realizar búsquedas de los maxisacos que se han repasado (maxisacos que se asignaron en columna "Viene de" de la bitácora) `},
                        {   tipo:`label`,   texto:`Se puede buscar por lote (digite el lote y presione la tecla Enter), por lote y maxisaco (digite el lote y el maxisaco separados por guión medio y presione Enter) o por un rango de fechas (seleccione fecha inicio y final).`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarInfo(){
            this.mostrarLoading({titulo:'Cargando Lotes...',color:'green'})
            let url = `${this.base_url}jumbos_reproceso/${this.fechas[0]}/${this.fechas[1]}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta',res.data.data);
                this.jumbos_reproceso = res.data.data;
                this.url = res.data.url;
                this.ocultarLoading();
            }).catch((error)=>{
                this.ocultarLoading();
                console.log('error',error);
                this.mostrarLoading({titulo:'Error... ' + error,color:'#e57373'})
            })
        },

        async buscar(){
            this.mostrarLoading({titulo:'Cargando Lotes...',color:'green'})
            let separar = this.lote_jumbo.split('-');
            let lote = '';
            let jumbo = '';
            if(this.lote_jumbo.includes('R')){
                lote = `${separar[0]}-${separar[1]}`;
                jumbo = `${separar[2]}`;
            }else{
                lote = `${separar[0]}`;
                jumbo = `${separar[1]}`;
            }
            console.log(lote,jumbo);
            let url = `${this.base_url}jumbo_reproceso/buscar/${lote}/${jumbo}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('busqueda',res.data.data);
                this.jumbos_reproceso = res.data.data;
                this.url = res.data.url;
            }).catch((error)=>{
                this.errorMessage(error, "Error al Cargar Lotes ");
            });
            this.ocultarLoading();
        },

        async buscarLote(){
            this.mostrarLoading({titulo:'Buscando Lote...',color:'green'})
            let url = `${this.base_url}jumbo_reproceso/buscar/${this.lote}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('busqueda',res.data.data);
                this.jumbos_reproceso = res.data.data;
                this.url = res.data.url;
            }).catch((error)=>{
                this.errorMessage(error, "Error al Buscar Lotes ");
            });
            this.ocultarLoading();
        },
        

        descargarExcel(){
            window.open(
              this.url, "_blank");
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda':ModalAyudas
    }
}
</script>
<style scoped>
.alto_tabla{
    height: 600px;
}
.borde-derecho{
    border-right:1px solid #CFD8DC;
}

.mx-datepicker {
    width: 50% !important;
    margin-top: 0px;
}
.tr-title th {
    background-color: #009688 !important;
    color: white !important;
}
</style>